import { render } from "./ColorPickerTextInput.vue?vue&type=template&id=68562ca4&scoped=true"
import script from "./ColorPickerTextInput.vue?vue&type=script&lang=js"
export * from "./ColorPickerTextInput.vue?vue&type=script&lang=js"

import "./ColorPickerTextInput.vue?vue&type=style&index=0&id=68562ca4&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68562ca4"]])

export default __exports__